import React from 'react';

import { Button, Icon } from '@iq/react-components';

const Pagination = ({ pages, page, setPage }) => {
  const canPreviousPage = page > 1;
  const canNextPage = page < pages;

  if (pages === null || pages < 2) {
    return null;
  }

  return (
    <div
      data-testid="pagination-container"
      className="panel-pagination"
    >
      <Button
        data-testid="first-page-button"
        icon={
          <Icon
            size="xs"
            icon="he-fastbackward"
          />
        }
        activity="secondary"
        onClick={() => setPage(1)}
        disabled={!canPreviousPage}
        slim
        tooltip="First page"
      />
      <Button
        data-testid="previous-page-button"
        icon={
          <Icon
            size="xs"
            icon="he-backwards"
          />
        }
        activity="secondary"
        onClick={() => setPage(page - 1)}
        disabled={!canPreviousPage}
        slim
        tooltip="Previous page"
      />
      <span data-testid="page-info">
        Page{' '}
        <strong>
          {' '}
          {page} of {pages}{' '}
        </strong>{' '}
      </span>
      <Button
        data-testid="next-page-button"
        icon={
          <Icon
            size="xs"
            icon="he-forwards"
          />
        }
        activity="secondary"
        onClick={() => setPage(page + 1)}
        disabled={!canNextPage}
        slim
        tooltip="Next page"
      />
      <Button
        data-testid="last-page-button"
        icon={
          <Icon
            size="xs"
            icon="he-fastforward"
          />
        }
        activity="secondary"
        onClick={() => setPage(pages)}
        disabled={!canNextPage}
        slim
        tooltip="Last page"
      />
    </div>
  );
};

export default Pagination;
